<template>
  <div class="main-body">

    <div class="header">智能手表</div>

    <div class="out" style="background-color: #fff;margin: 10px">

      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="社区护士" name="three">
          <Part3 ref="myPart3"></Part3>
        </el-tab-pane>
        <el-tab-pane label="服务人员" name="first">
          <Part1 ref="myPart1"></Part1>
        </el-tab-pane>
        <el-tab-pane label="老人" name="second">
          <Part2 ref="myPart2"></Part2>
        </el-tab-pane>
      </el-tabs>

<!--      <el-tabs v-model="activeTab" @tab-remove="handleClose">-->
<!--        <el-tab-pane-->
<!--            v-for="tab in tabs"-->
<!--            :key="tab.path"-->
<!--            :name="tab.path"-->
<!--            :label="tab.name"-->
<!--            closable-->
<!--        />-->
<!--      </el-tabs>-->


    </div>

  </div>
</template>

<script>

import Part1 from "./PageServe";
import Part2 from "./PageUser";
import Part3 from "./PageNurse";

export default {
  name: 'ElderlyInsCheckIn',
  data() {
    return {

      loading: false,

      activeName: '',


      activeTab:'/Assess/GovPage',
      tabs:[],

    }
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th=val
    },
  },
  components:{
    Part1,Part2,Part3
  },
  mounted() {
    this.init();

    //this.tabs.push({ path: '/Assess/GovPage', name: 'Assess' });
    //this.tabs.push({ path: '/AccidentRecord/GovPageIns', name: 'AccidentRecord' });

  },
  created() {
    this.th = this.$store.state.tableHeight;

  },
  methods: {
    init(){

      this.activeName = 'three';
      this.$refs.myPart3.init();

    },

    handleClick(tab, event) {
      //console.log(tab, event);
      //console.log(tab.name);

      if(tab.name == 'first'){
        this.$refs.myPart1.init();
      }
      if(tab.name == 'second'){
        this.$refs.myPart2.init();
      }
      if(tab.name == 'three'){
        this.$refs.myPart3.init();
      }

    },

    handleClose(){

    },

  }
}


</script>

<style lang="scss" scoped>

</style>
